<div
        class="tile"
        [class.tile--clickable]="isClickable"
        (click)="onClick.emit()"
>
    <img
            class="promotion__image"
            [src]="promotion.image"
            [alt]="promotion.name + ' image'"
    />
    <div class="promotion__info">
        <p class="promotion__code">
            {{ "product_tile.reference_abbreviation" | translate }}
            {{ promotion.code }}
        </p>
        <p class="promotion__name">{{ promotion.name }}</p>
        <div class="row">
            <div class="promotion__details">
                <div class="row prices" *ngIf="canDisplayPrice">
                    <p class="promotion__price">
                        {{ promotion.price | localizedCurrency }}
                    </p>
                    <p class="promotion__discounted-price">
                        {{
                        promotion.discountedPrice != 0
                            ? (promotion.discountedPrice | localizedCurrency)
                            : ("promotions.free_promotion" | translate)
                        }}
                    </p>
                </div>
            </div>
            <app-add-promotion-to-cart-button
                    class="add-to-cart"
                    [promotionCode]="promotion.code"
            ></app-add-promotion-to-cart-button>
        </div>
        <div
                *ngIf="promotion.endDate"
                class="promotion__end-date">
            {{ "promotions.valid_until_date" | translate: { date: promotion.endDate | localizedDate } }}
        </div>
    </div>
</div>
